var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithDraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 83,
    viewBox: "0 0 95 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M47.5004 82.7C73.513 82.7 94.6003 81.5359 94.6003 80.1C94.6003 78.6641 73.513 77.5 47.5004 77.5C21.4878 77.5 0.400391 78.6641 0.400391 80.1C0.400391 81.5359 21.4878 82.7 47.5004 82.7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6006 29.3002C28.7006 36.3002 32.7006 42.6002 37.8006 48.1002C41.7006 49.3002 49.8006 51.1002 49.8006 51.1002L56.9006 45.7002C49.6006 39.8002 43.7006 32.9002 39.6006 24.6002C38.9006 23.2002 38.2006 21.7002 37.6006 20.2002L32.0006 24.4002L25.6006 29.3002Z",
    fill: "#74B743"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4002 25.4998C67.6002 33.5998 65.6002 41.2998 62.3002 48.5998C58.8002 51.0998 51.2002 55.5998 51.2002 55.5998L42.2002 52.4998C48.6002 42.6998 52.6002 32.0998 53.3002 20.2998L68.4002 25.4998Z",
    fill: "#74B743"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2 27.8006C68.4 35.9006 66.4 43.6006 63.1 50.9006C59.6 53.4006 52 57.9006 52 57.9006L43 54.8006C49.4 45.0006 53.4 34.4006 54.1 22.6006L69.2 27.8006Z",
    fill: "#74B743"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3006 24.8006C65.5006 32.9006 63.5006 40.6006 60.2006 47.9006C56.7006 50.4006 49.1006 54.9006 49.1006 54.9006L40.1006 51.8006C46.5006 42.0006 50.5006 31.4006 51.2006 19.6006L66.3006 24.8006Z",
    fill: "#09314C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5008 17.4998C65.7008 25.5998 63.7008 33.2998 60.4008 40.5998C56.9008 43.0998 49.3008 47.5998 49.3008 47.5998L40.3008 44.4998C46.7008 34.6998 50.7008 24.0998 51.4008 12.2998L66.5008 17.4998Z",
    fill: "#74B743"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4001 42.5004L65.8 71.3004C64.6 76.0004 60.3001 79.3004 55.4001 79.3004H44.2C39.3 79.3004 35.1 76.0004 33.8 71.3004L27.4001 48.3004C27.1001 47.1004 25.7 40.0004 25.8 38.8004C25.8 38.8004 27 44.6004 27 44.5004C27 44.1004 25.9001 37.9004 25.9001 37.5004L27.1 43.3004L37.8 39.9004L42.7 47.5004L50.1 34.7004L57.4001 41.6004L72.2 32.4004C73 34.4004 73.5 36.5004 73.7 38.8004C73.8 40.0004 73.7001 41.2004 73.4001 42.5004Z",
    fill: "white",
    stroke: "#09314C",
    strokeWidth: 3.0039,
    strokeMiterlimit: 1,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3 14.4002L54.5999 31.3002L46.8 28.0002L46.0999 27.7002L45.8 28.8002L43.0999 38.4002L37.7 35.8002L35 34.5002L27.7 43.0002C27.4 42.3002 27.1 41.5002 26.8 40.8002C25.8 37.7002 25.4 34.5002 25.7 31.3002C26.2 25.1002 29.2 19.3002 33.8 15.3002C34 15.1002 34.8 14.4002 34.8 14.4002L34 14.1002L29.9 12.4002C29 12.0002 28.5 11.2002 28.5 10.2002L28.8 4.1002C28.8 3.5002 29.1 3.0002 29.5 2.6002L29.5999 2.50019C29.6999 2.40019 29.7 2.40018 29.8 2.30018C29.9 2.30018 30 2.2002 30 2.2002C30.1 2.2002 30.1 2.1002 30.2 2.1002C30.7 1.9002 31.3 1.9002 31.8 2.1002L37.4 4.50019C38.3 4.90019 38.8 5.7002 38.8 6.7002L38.5 12.0002C38.5 12.0002 39.5 11.5002 39.9 11.3002C47.5 8.00018 56.3 9.00019 62.9 13.5002C63.6 13.9002 63.9 14.1002 64.3 14.4002Z",
    fill: "white",
    stroke: "#09314C",
    strokeWidth: 3.0039,
    strokeMiterlimit: 1,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 77.3002C58 79.1002 72.9 78.9002 72.9 78.9002C72.9 78.9002 80.9 78.2002 81.9 77.8002C82.4 75.0002 82.5 71.1002 82.5 71.1002V62.2002C73.4 64.5002 64.3 65.0002 55.2 63.3002C53.6 63.0002 52.1 62.6002 50.5 62.2002V69.2002V77.3002Z",
    fill: "#74B743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithDraw);
export default __webpack_public_path__ + "static/media/withDraw.6c93229b5d0c9ec1effd4f3aea2820a1.svg";
export { ForwardRef as ReactComponent };